module.exports = __webpack_public_path__ + "school/img/pingtaijieshao.b963bf6b.jpg";